<template lang="pug">
    layout

        // Title
        title-component(
            :title="$t('profile.navigation[3].title')"
            slot="title"
            type="h2"
        )

        div

            // Password change form
            password-form(ref="passwordForm")

        v-layout(raw wrap)
            v-flex(xs12)

                // Horizontal line
                separator-component

                div.controls
                    div

                        // Cancel button
                        button-component.ml-0(
                            :action="cancel"
                            :isLoading="isLoading"
                            color="grey"
                            large
                            outline
                        ) {{ $t('defaultButtons.cancel') }}

                    div

                        // Submit button
                        button-component.mr-0.submit(
                            color="primary"
                            :action="submit"
                            :isLoading="isLoading"
                            large
                        ) {{ $t('defaultButtons.save') }}
</template>

<script>
    import Layout from '../Layout';
    import UpdatePasswordForm from './UpdatePasswordForm';
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            Layout,
            PasswordForm: UpdatePasswordForm,
            TitleComponent: Title,
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        computed: {
            ...mapGetters('auth', ['isInstructor', 'isLoading'])
        },
        methods: {
            /**
             * Clear form
             */
            cancel() {
                this.$refs.passwordForm.clearForm();
            },

            /**
             * Update password
             */
            submit() {
                this.$refs.passwordForm.submitForm();
            }
        }
    };
</script>

<style lang="stylus" scoped></style>
